import i18next from '../services/i18n';

// Without the order we can't tell why it closed; in practice a refused month has almost always expired.
export const unavailableMonthMessage = (order) =>
  !order || (order.metadata || {}).archivedReason === 'expired-18m'
    ? i18next.t('Order.expiredMonth.message', {
        defaultValue: 'This month has expired. Months older than 18 months can no longer be ordered.',
      })
    : i18next.t('Order.closedMonth.message', { defaultValue: 'This month is no longer available.' });
